import React from 'react';
import * as LucideIcons from 'lucide-react';

const ProcessSteps = () => {
  const steps = [
    {
      number: '01',
      title: 'Get In Touch',
      description: 'Contact us via phone, WhatsApp, or our online form with details about your project.',
      icon: LucideIcons.MessageSquare
    },
    {
      number: '02',
      title: 'Free Survey & Quote',
      description: 'We\'ll visit your property to assess the work and provide a detailed, no-obligation quote.',
      icon: LucideIcons.ClipboardList
    },
    {
      number: '03',
      title: 'Schedule Your Project',
      description: 'Once you\'re happy with the quote, we\'ll agree on a start date that works for you.',
      icon: LucideIcons.Calendar
    },
    {
      number: '04',
      title: 'Quality Workmanship',
      description: 'Our skilled team carries out the work to the highest standards with minimal disruption.',
      icon: LucideIcons.Hammer
    },
    {
      number: '05',
      title: 'Final Inspection',
      description: 'We walk through the completed project with you to ensure your complete satisfaction.',
      icon: LucideIcons.CheckCircle2
    }
  ];

  return (
    <section className="py-20 bg-gray-900 text-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-orange-500 font-semibold text-sm uppercase tracking-wider">Our Process</span>
          <h2 className="text-3xl md:text-4xl font-bold mt-2 mb-4">How It Works</h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            From initial enquiry to project completion, we make the process simple and stress-free
          </p>
        </div>

        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-orange-600/30 transform -translate-y-1/2" />
          
          <div className="grid md:grid-cols-5 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative text-center group">
                {/* Step Number Circle */}
                <div className="relative z-10 w-20 h-20 bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-6 border-4 border-orange-600 group-hover:bg-orange-600 transition-all duration-300">
                  <step.icon className="w-8 h-8 text-orange-500 group-hover:text-white transition-colors" />
                </div>
                
                {/* Step Number Badge */}
                <div className="absolute top-0 right-1/2 transform translate-x-12 -translate-y-2 bg-orange-600 text-white text-xs font-bold px-2 py-1 rounded">
                  {step.number}
                </div>
                
                <h3 className="font-bold text-lg mb-2">{step.title}</h3>
                <p className="text-gray-400 text-sm">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSteps;
